import PropTypes from 'prop-types';
import { Box, Divider, Drawer, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  AddOutlined,
  CalendarMonthOutlined,
  GridViewOutlined,
  HomeOutlined,
  MailOutlineOutlined,
  MessageOutlined,
  SettingsOutlined,
  EmailOutlined,
  ExitToAppOutlined,
  PeopleOutlined,
  DashboardOutlined,
  DescriptionOutlined,
} from '@mui/icons-material';

import { Profile, SidebarNav } from './components';

const Sidebar = props => {
  const { open, onClose, ...rest } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  // Render sidebar only on mobile/tablet
  if (!isMobile) {
    return null;
  }

  const pages = [
   {
        icon: <HomeOutlined />,
        label: 'Home',
        path: '/default'
      },
      {
        dot: true,
        icon: <MessageOutlined />,
        label: 'Communications',
        path: '/communications'
      },
      {
        icon: <CalendarMonthOutlined />,
        label: 'Schedule',
        path: '#'
      },
      {
        dot: true,
        icon: <MailOutlineOutlined />,
        label: 'PT Messages',
        path: '/pt-message'
      },
      {
        icon: <GridViewOutlined />,
        label: 'Templates',
        path: '#'
      },
      {
        icon: <SettingsOutlined />,
        label: 'Settings',
        path: '/settings'
      },
    {
      label: 'Sign out',
      path: '/sign-in',
      icon: <ExitToAppOutlined />
    }
  ];

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      variant="temporary"
      ModalProps={{
        keepMounted: true
      }}
      slotProps={{
        paper: {
          sx: {
            width: 260,
            backgroundColor: '#F9F5EF',
            borderRight: '1px solid #F5E9D6'
          }
        }
      }}>
      <Box
        {...rest}
        sx={{
          backgroundColor: '#F9F5EF',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          p: 2,
          color: '#9B6A2F'
        }}>
        <Profile />

        <Divider sx={{ my: 2 }} />

        <SidebarNav pages={pages} />

        {/* <Box sx={{ mt: 'auto' }}>
          <UpgradePlan />
        </Box> */}
      </Box>
    </Drawer>
  );
};

Sidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};

export default Sidebar;
